import React from "react";
import UserFormFields from "components/UserFormFields";
import { createOne } from "actions/user";
import { connect } from "react-redux";
import * as R from "ramda";
import { fetchAll } from "actions/location";

const mapDispatchToProps = {
  createOne,
  fetchAll
};

const mapStateToProps = state => ({
  locations: state.location.byId,
  isFetching: state.location.isFetching
});

class AdminUserCreate extends React.Component {
  state = {
    user: {
      company: "",
      location_id: ""
    }
  };

  componentWillMount() {
    this.props.fetchAll();
  }

  handleSubmit = event => {
    event.preventDefault();
    const { createOne, history } = this.props;
    const { user } = this.state;
    createOne(user).then(data => {
      history.push("/admin/user/list");
    });
  };

  handleChange = (fields, value) => {
    this.setState(R.assocPath(fields, value));
  };

  render() {
    const { locations, isFetching } = this.props;
    const items = Object.keys(locations).map(id => locations[id]);
    if (!(!isFetching && items)) {
      return null;
    }

    return (
      <form onSubmit={this.handleSubmit}>
        <div className="form-group">
          <UserFormFields
            user={this.state.user}
            onChange={this.handleChange}
            nocustomer
            nodate
            location={items}
          />
          <button id="submit" name="submit" className="btn btn-primary">
            Legg til lokasjon
          </button>
        </div>
      </form>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminUserCreate);



// WEBPACK FOOTER //
// ./src/components/AdminUserCreate.js